const DotsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.25" cy="7.25" r="1.25" fill="#5E718D" />
      <circle cx="12.25" cy="12.25" r="1.25" fill="#5E718D" />
      <circle cx="12.25" cy="17.25" r="1.25" fill="#5E718D" />
    </svg>
  );
};

export default DotsIcon;
